export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/a693fed4ea610da49568f7acdf7a53bd.png";